import create from './Container';
import * as events from './events';
var Tooltip = create(events);
Tooltip.displayName = 'ShineoutTooltip';
export default Tooltip;